<div class="container">
    <pdf-viewer [src]="pdfSrcEN" [render-text]="true"
            (after-load-complete)="afterLoadComplete($event)">
    </pdf-viewer>
</div>

<ngx-ui-loader></ngx-ui-loader>
